var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuidesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8537 19.9446C10.8529 20.2014 10.7845 20.4537 10.6551 20.6776C10.5257 20.9014 10.3395 21.0895 10.1143 21.2238C9.88901 21.3581 9.63214 21.4342 9.36806 21.445C9.10398 21.4557 8.84146 21.4007 8.60543 21.2852L2.40333 18.2727C2.14762 18.1476 1.93259 17.9561 1.78207 17.7194C1.63154 17.4828 1.5514 17.2103 1.55054 16.9322V1.86995L10.0009 5.96688C10.259 6.09319 10.4756 6.28705 10.6262 6.52658C10.7769 6.76611 10.8557 7.04177 10.8537 7.32248V19.9446Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55054 1.86995H15.5053C15.9165 1.86995 16.3109 2.02864 16.6016 2.31111C16.8924 2.59358 17.0558 2.9767 17.0558 3.37617V16.9322C17.0558 17.3317 16.8924 17.7148 16.6016 17.9973C16.3109 18.2797 15.9165 18.4384 15.5053 18.4384H10.8537",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidesIcon);
export default __webpack_public_path__ + "static/media/guides-icon.089193f8872e82d31fa230a9f12af2ed.svg";
export { ForwardRef as ReactComponent };